export const FILE_SIZE_LIMIT = 1073741824